module.exports = "/fonts/eppt-picturemark-l-cd6a3482cd2df3e6cc367560c88e0c87.svg";